import {setupDevtoolsPlugin} from "@vue/devtools-api";

/**
 * Raggruppa e customizza l'aspetto di tutti i warning e gli errori vue in group collassabili
 * @param app
 */
export function customizeVueWarningAndError(app) {
  app.config.errorHandler = function (err, vm, info) {
    console.groupCollapsed('%c Vue Error! ', 'background: #90002f; color: #111');
    console.log(err, info);
    console.groupEnd();
  }
  app.config.warnHandler = function (err, vm, info) {
    console.groupCollapsed('%c Vue Warning! ', 'background: #ffd580; color: #111');
    console.log(err, info, vm);
    console.groupEnd();
  }
}

/**
 * Aggiunge all'istanza Vue le direttive custom
 * @param app
 */
export function addCustomVueDirective(app) {
  // gestisce il click outside dell'elemento agganciato
  app.directive('click-outside', {
    beforeMount: function (element, binding, vnode) {
      element.clickOutsideEvent = function (event) {  //  check that click was outside the el and his children
        if ((!(element === event.target || element.contains(event.target))) && (!event.target.classList.contains('js-no-click-away'))) { // and if it did, call method provided in attribute value
          binding.value(event);
        }
      };
      document.body.addEventListener('click', element.clickOutsideEvent)
    },
    unmounted: function (element) {
      document.body.removeEventListener('click', element.clickOutsideEvent)
    }
  });
}

/**
 * Imposta il plugin fallco nel devtool di vue
 * Aggiunge alla lista dei componenti un riferimento prelevato dalla props (name o id) per
 * meglio identificarlo in caso di molti componenti
 * Aggiunge una sezione del vue dev tool con la lista degli endpoint nell'applicativo
 */
export function setDevToolPlugin(app) {
  const FALLCO_DEVTOOL_ID = 'fallco-custom-vue-devtool';

  setupDevtoolsPlugin({
    id: 'fallco-custom-vue-devtool',
    label: 'Fallco Custom Vue Devtool',
    packageName: 'fallco-custom-vue-devtool',
    homepage: 'https://www.fallco.it/',
    logo: 'https://www.fallco.it/public/resources/img/logo/logo_fallco.png',
    app
  }, api => {
    api.on.visitComponentTree((payload, context) => {
      const node = payload.treeNode
      let instanceName = (payload.componentInstance.props.id) ? payload.componentInstance.props.id : (payload.componentInstance.props.name) ? payload.componentInstance.props.name : null
      if (instanceName) {
        node.tags.push({
          label: instanceName,
          textColor: 0xffffff,
          backgroundColor: 0x111
        })
      }
    })

    api.on.getInspectorTree(function (payload) {
      if (payload.app === app && payload.inspectorId === FALLCO_DEVTOOL_ID) {
        payload.rootNodes = [
          formatFallcoInspectorTree(endpoints, '')
        ];
      }
    });
  })

  /**
   * Crea l'albero delle api dell'applicativo da mostrare nel vue devtool
   * @param module
   * @param path
   * @private
   * @returns {any}
   */
  function formatFallcoInspectorTree (module, path) {
    return {
      id: path || 'root',
      label: extractNameFromPath(path),
      children: Object.keys(module).map(function (moduleName) { return formatFallcoInspectorTree(
          module[moduleName],
          path + moduleName + '/'
        ); }
      )
    }
  }

  /**
   * Estrae la label dal path per il vue devtool
   * @param path
   * @private
   * @returns {*|string}
   */
  function extractNameFromPath (path) {
    return path && path !== 'root' ? path.split('/').slice(-2, -1)[0] : 'Root'
  }

}